export const IS_REGISTERING = 'IS_REGISTERING';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const LOADING_CLIENT = "LOADING_CLIENT";
export const LOAD_CLIENT_SUCCESS = "LOADING_CLIENT_SUCCESS";
export const UPDATING_CLIENT = "UPDATING_CLIENT"
export const UPDATING_CLIENT_SUCCESS = "UPDATING_CLIENT_SUCCESS"
export const UPDATING_CLIENT_ERROR = "UPDATING_CLIENT_ERROR"